import { useTranslation } from 'react-i18next';
import TitleComponent from '../../components/widgets/titleComponent';
import { Box, Stack } from '@mui/material';
import { useCallback, useState } from 'react';
import YouTube from 'react-youtube';
import careersData from '../../assets/data/careers/careers.json';

const CareersHero = () => {
    const {t} = useTranslation();

    const [youtubeVideoError, setYoutubeVideoError] = useState(false);

    const OnYoutubeError = useCallback((event) => {
        // // The event contains a data property with the error code.
        // const errorCode = event.data;

        // // Map the YouTube error code to a readable message
        // let errorMessage = '';
        
        // switch (errorCode) {
        //     case 2:
        //         errorMessage = t(`errors.youtube_video.invalid`);
        //         break;
        //     case 5:
        //         errorMessage = t(`errors.youtube_video.player_error`);
        //         break;
        //     case 100:
        //         errorMessage = t(`errors.youtube_video.not_found`);
        //         break;
        //     case 101:
        //     case 150:
        //         errorMessage = t(`errors.youtube_video.restricted`);
        //         break;
        //     default:
        //         errorMessage = t(`errors.youtube_video.unknown`);
        // }

        setYoutubeVideoError(true);
    }, []);

    const getYoutubeVideoID = useCallback(() => {
        const url = careersData.heroVideo;

        var regExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)[\w\-]{11}(?:[&?][^\s]*)?$/;
        var match = url.match(regExp);

        if (match) {
            const regExp = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
            return regExp.exec(url)[3];
        }
        else {
            // setYoutubeVideoError(t(`errors.youtube_video.invalid`));
            setYoutubeVideoError(true);

            return null;
        }
    }, [careersData]);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                px='5%'
            >  
                <TitleComponent 
                    title={t('careers.title')}
                    description={t('careers.description')}
                    centerMode
                />

                <Box width='100%'>
                    {
                        youtubeVideoError
                        ?
                        <></>
                        :
                        <Box width='100%' sx={{backgroundColor: 'black'}}>
                            <YouTube 
                                videoId={getYoutubeVideoID()}
                                opts={{
                                    width: '100%',
                                    height: window.innerWidth < 600 ? 250 : 500,
                                    playerVars: {
                                        // https://developers.google.com/youtube/player_parameters
                                        autoplay: 0,
                                        color: 'white'
                                    }
                                }}
                                onError={OnYoutubeError}
                                onReady={() => setYoutubeVideoError(false)}
                            />
                        </Box>
                    }
                </Box>
            </Stack>
        </>
    );
}

export default CareersHero;